import { render, staticRenderFns } from "./TurnplateLottery.vue?vue&type=template&id=64b0abd7"
import script from "./TurnplateLottery.vue?vue&type=script&lang=js"
export * from "./TurnplateLottery.vue?vue&type=script&lang=js"
import style0 from "./TurnplateLottery.vue?vue&type=style&index=0&id=64b0abd7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports